export const getWeChatLoginUrl = (state = 'STATE', domain = '') => {
  const AppId = localStorage.getItem('AppId')
  // const DomainName = localStorage.getItem('DomainName')
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${AppId}&redirect_uri=${encodeURIComponent(`${domain}`)}&response_type=code&scope=snsapi_userinfo&state=` + state + `#wechat_redirect`
}

const setCookie = (cName, value, expireDays) => {
  const expireDate = new Date()
  expireDate.setDate(expireDate.getDate() + expireDays)
  document.cookie = cName + '=' + escape(value) + ';expires=' + expireDate.toGMTString()
}

const getCookie = (cName) => {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(cName + '=')
    let cEnd
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1
      cEnd = document.cookie.indexOf(';', cStart)
      if (cEnd === -1) {
        cEnd = document.cookie.length
      }
      return unescape(document.cookie.substring(cStart, cEnd))
    }
  }
  return ''
}

export const saveValueToStorage = (key, value) => {
  try {
    localStorage.setItem(key, value)
  } catch (e) {
    console.log(e)
    setCookie(key, value, 3650)
  }
}

export const getValueFromStorage = (key) => {
  let value
  try {
    value = localStorage.getItem(key)
  } catch (e) {
    console.log(e)
    value = getCookie(key)
  }
  return value
}

export const removeValueInStorage = (key) => {
  try {
    localStorage.removeItem(key)
  } catch (e) {
    deleteCookie(key)
  }
}

const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}

export const formatDate = (time = new Date(), type) => {
  if (!time) {
    return ''
  }
  const d = new Date(time)
  const year = d.getFullYear()
  const month = getHandledValue(d.getMonth() + 1)
  const date = getHandledValue(d.getDate())
  const hours = getHandledValue(d.getHours())
  const minutes = getHandledValue(d.getMinutes())
  const second = getHandledValue(d.getSeconds())
  let resStr = ''
  if (type === 'year') {
    resStr = year + '-' + month + '-' + date + ' ' + hours + ':' + minutes + ':' + second
  } else if (type === 'date') {
    resStr = year + '-' + month + '-' + date
  } else {
    resStr = month + '-' + date + ' ' + hours + ':' + minutes
  }
  return resStr
}

export const formatSeconds = (seconds) => {
  let h = parseInt(seconds / 60 / 60 % 24)
  const hb = h
  h = h < 10 ? '0' + h : h
  let m = parseInt(seconds / 60 % 60)
  m = m < 10 ? '0' + m : m
  let s = parseInt(seconds % 60)
  s = s < 10 ? '0' + s : s
  if (hb) {
    return `${h}时${m}分${s}秒`
  } else {
    return `${m}分${s}秒`
  }
}

export const formatMoney = (num) => {
  return String(num).replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, '$1,')
}

export const hasOneOf = (targetArr, arr) => {
  targetArr = targetArr || []
  arr = arr || []
  return targetArr.some(_ => arr.indexOf(_) > -1)
}

export const getRandomColor = () => {
  let color = '#'
  const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f']
  for (let i = 0; i < 6; i++) {
    const c = parseInt(Math.random() * 16)
    color = color + arr[c]
  }
  return color
}
